import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const TestPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom>
          ✅ React is running successfully!
        </Typography>
        <Typography variant="h5" color="text.secondary" sx={{ mb: 4 }}>
          React + Material-UI + TypeScript
        </Typography>
        <Button 
          variant="contained" 
          size="large"
          onClick={() => navigate('/login')}
        >
          Go to login page
        </Button>
      </Box>
    </Container>
  );
};

export default TestPage;
